import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { LoginComponent } from './login.component';
import { LogoutSsoComponent } from './logout-sso/logout-sso.component';
import { SsoComponent } from './sso/sso.component';
import { EndSessionComponent } from './end-session/end-session.component';
import { IdleTimeoutComponent } from './idle-timeout/idle-timeout.component';
import { SignoutMessageComponent } from './signout-message/signout-message.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { SigninCallbackComponent } from './signin-callback/signin-callback.component';
import { SignoutCallbackComponent } from './signout-callback/signout-callback.component';
import { PostLogoutComponent } from './post-logout/post-logout.component';
import { WithNoAuthComponent } from '../container/with-no-auth/with-no-auth.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetLoginComponent } from './reset-login/reset-login.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { TimeSyncComponent } from './time-sync/time-sync.component';
import { NotFound404Component } from './404/404.component';
import { OopsComponent } from './oops/oops.component';
import { PreLogoutComponent } from './pre-logout/pre-logout.component';
import { RecoveryCodeComponent } from './recovery-code/recovery-code.component';
import { RecoveryCodeVerificationComponent } from './recovery-code-verification/recovery-code-verification.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { EmailVerificationComponent } from '@app/auth/login/email-verification/email-verification.component';
import { SMSVerificationComponent } from '@app/auth/login/sms-verification/sms-verification.component';
import { MFANotAllowComponent } from './mfa-not-allow/mfa-not-allow.component';

const routes: Routes = [
  {
    path: '',
    component: WithNoAuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: { title: extract('Login') },
      },
      {
        path: 'login/:id',
        component: LoginComponent,
        data: { title: extract('Login') },
      },
      {
        path: 'sso',
        component: SsoComponent,
        data: { title: extract('sso') },
      },
      {
        path: 'logoutsso',
        component: LogoutSsoComponent,
        data: { title: extract('Logout') },
      },
      {
        path: 'endsession',
        component: EndSessionComponent,
        data: { title: extract('End Session') },
      },
      {
        path: 'idle-timeout',
        component: IdleTimeoutComponent,
        data: { title: extract('Idle Timeout') },
      },
      {
        path: 'signin-callback',
        component: SigninCallbackComponent,
        data: {
          breadcrumb: 'signin-callback',
        },
      },
      {
        path: 'signout-callback',
        component: SignoutCallbackComponent,
        data: {
          breadcrumb: 'sigout-callback',
        },
      },
      { path: 'post-logout', component: PostLogoutComponent },

      {
        path: 'idle-timeout',
        component: IdleTimeoutComponent,
        data: {
          breadcrumb: 'idle-timeout',
        },
      },
      {
        path: 'signout-message',
        component: SignoutMessageComponent,
        data: {
          breadcrumb: 'signout-message',
        },
      },
      {
        path: 'recovery-code',
        component: RecoveryCodeComponent,
        data: {
          breadcrumb: 'recovery-code',
        },
      },
      {
        path: 'recovery-code-verification',
        component: RecoveryCodeVerificationComponent,
        data: {
          breadcrumb: 'recovery-code-verification',
        },
      },
      {
        path: 'email-verification',
        component: EmailVerificationComponent,
        data: {
          breadcrumb: 'email-verification',
        },
      },
      {
        path: 'sms-verification',
        component: SMSVerificationComponent,
        data: {
          breadcrumb: 'sms-verification',
        },
      },
      { path: 'reset-login', component: ResetLoginComponent },
      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'forbidden', component: ForbiddenComponent },
      { path: 'oops', component: OopsComponent },
      { path: 'time-sync', component: TimeSyncComponent },
      { path: 'page-not-found', component: NotFound404Component },
      { path: 'logout', component: PreLogoutComponent },
      {
        path: 'mfa-notsupported',
        component: MFANotAllowComponent,
        data: {
          breadcrumb: 'mfa-not-allow',
        },
      },
    ],
  },
  {
    path: 'forgotpassword',
    component: ForgetPasswordComponent,
    data: {
      breadcrumb: 'forgot-password',
    },
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: {
      breadcrumb: 'reset-password',
    },
  },
  {
    path: 'code-verification',
    component: CodeVerificationComponent,
    data: {
      breadcrumb: 'code-verification',
    },
  },
  {
    path: 'set-password',
    component: SetPasswordComponent,
    data: {
      breadcrumb: 'set-password',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LoginRoutingModule {}
